import { SessionInterface } from '../../../core';

export class Session implements SessionInterface {
    private readonly _code: string = undefined;
    private readonly _domain: string = undefined;
    private readonly _language: string = undefined;
    private _token: string = undefined;
    private readonly _admin: boolean = undefined;
    private readonly _isAdminPBC: boolean = undefined;

    constructor(code: string, domain: string, language: string, token: string, admin = false, isAdminPBC = false) {
        this._code = code;
        this._domain = domain;
        this._language = language;
        this._token = token;
        this._admin = admin;
        this._isAdminPBC = isAdminPBC;
    }

    get code(): string {
        return this._code;
    }

    get domain(): string {
        return this._domain;
    }

    get language(): string {
        return this._language;
    }

    get token(): string {
        return this._token;
    }

    set token(value: string) {
        this._token = value;
    }

    get admin(): boolean {
        return this._admin;
    }

    get isAdminPBC(): boolean {
        return this._isAdminPBC;
    }
}
